import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

const DashboardSummarySection = () => {
    return (
        <Container>
            <Grid container spacing={1}>
                <Grid 
                    size={{xs:12, sm:12, md:7}}
                    sx={{ 
                        justifyContent: 'left', 
                        textAlign: 'left', 
                        marginLeft:{xs:"1.2REM", sm:"1.2REM", md:"0REM"}, 
                        marginRight:{xs:"1.2REM", sm:"1.2REM", md:"0REM"}, 
                        marginBottom: 5 
                    }}
                >
                    <Container>
                        <Typography 
                            marginTop="20px" 
                            marginBottom="20px" 
                            marginLeft="20px" 
                            fontFamily={"Roboto"} 
                            fontSize={"2.5REM"} 
                            fontWeight={800}
                            textAlign={{xs:"center", md:"left"}}>
                            Unlock valuable insights with the
                            Sigmatiqa dashboard
                        </Typography>

                        <Typography variant="body1" 
                                sx={{ 
                                    fontFamily: 'Roboto, Arial, sans-serif',
                                    fontSize: 20, 
                                    fontWeight: 'regular', 
                                    color: '#4d4d4d', 
                                    marginTop: 1
                                }}>
                            {/*Our easy to use dashboard is designed to provide you with relevant information required to run your business smoothly and efficiently. From temperatures and compliance warnings to battery life indication, you will be able to see all meaningful  and actionable data in one single screen. All temperature data is securely stored for up to 5 years and is available to view anytime you require.*/}
                            Our intuitive dashboard empowers you with the insights that matter most to your business. Monitor temperatures, receive real-time compliance alerts, and check battery health—all from a single, easy-to-navigate screen. Every data point is stored securely for up to 5 years, giving you peace of mind and access whenever you need it.
                        </Typography>
                            
                        <Box
                            component="img"
                            src="./Dashboard2.jpeg"
                            alt="Dashboard Page"
                            sx={{
                                objectFit: 'cover',
                            }}
                        />
                    </Container>
                </Grid>
                <Grid 
                    size={{xs:12, sm:12, md:5}}
                    sx={{ 
                        textAlign: 'left', 
                        objectFit: {xs:'scale-down', md: 'scale-down'}
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden', // Hides the left-overlapping part
                            display: 'flex',
                            justifyContent: {xs:'flex-start', sm:'flex-start', md:'flex-start'}, // Align image to the right
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            component="img"
                            src="./Dashboard1.jpeg"
                            alt="Dashboard Page"
                            sx={{
                                objectFit: {xs:'contain', md: 'scale-down'}
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default DashboardSummarySection;